/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donut Chart Maker (Free, Online) — Toolverse`)
};

const es_donut_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Gráficos de Dona (Gratis, Online) — Toolverse`)
};

const de_donut_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donut-Diagramm-Ersteller (Kostenlos, Online) — Toolverse`)
};

const nl_donut_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donutdiagrammaker (gratis, online) — Toolverse`)
};

const fr_donut_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de diagramme en anneau (gratuit, en ligne) — Toolverse`)
};

const it_donut_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di grafici a ciambella (gratuito, online) — Toolverse`)
};

const pt_br2_donut_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Gráfico de Rosca (Grátis, Online) — Toolverse`)
};

const pt_donut_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráficos de Rosca (Grátis, Online) — Toolverse`)
};

const ja_donut_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドーナツグラフ作成ツール（無料・オンライン） — Toolverse`)
};

const zh_donut_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`环形图制作工具（免费在线）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_meta_title", locale)
	if (locale === "en") return en_donut_meta_title(inputs)
	if (locale === "es") return es_donut_meta_title(inputs)
	if (locale === "de") return de_donut_meta_title(inputs)
	if (locale === "nl") return nl_donut_meta_title(inputs)
	if (locale === "fr") return fr_donut_meta_title(inputs)
	if (locale === "it") return it_donut_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_donut_meta_title(inputs)
	if (locale === "pt") return pt_donut_meta_title(inputs)
	if (locale === "ja") return ja_donut_meta_title(inputs)
	return zh_donut_meta_title(inputs)
};